import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import Particle from "../Particle";

import syepMain from "../../Assets/syepMain.png";
import cf2025 from "../../Assets/syep_2025.jpeg";
import cfCommunity1 from "../../Assets/cf-community-1.png";
import cfCommunity2 from "../../Assets/cf-community-2.png";
import cfCommunity3 from "../../Assets/cf-community-3.png";
import cfCommunity4 from "../../Assets/cf-community-4.png";
import cfCommunity6 from "../../Assets/cf-community-6.png";
import cfCommunity7 from "../../Assets/cf-community-7.png";
import cfCommunity8 from "../../Assets/cf-community-8.png";
import cfCommunity9 from "../../Assets/cf-community-9.png";
import cfCommunity10 from "../../Assets/cf-community-10.png";

import { Trans, useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";

const CONTACT_FORM_URL =
  "https://docs.google.com/forms/d/1iwEzu53wDAe41RjEDe-gHIX9H61QikSfR2RKmyCBp_M/edit?pli=1";

function PartnerWithUs() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const sliderImages = [
    { src: cfCommunity1, altKey: "aboutWho.sliderAlts.2" },
    { src: syepMain, altKey: "aboutWho.sliderAlts.0" },
    { src: cfCommunity6, altKey: "aboutWho.sliderAlts.7" },
    { src: cfCommunity2, altKey: "aboutWho.sliderAlts.3" },
    { src: cfCommunity3, altKey: "aboutWho.sliderAlts.4" },
    { src: cf2025, altKey: "aboutWho.sliderAlts.1" },
    { src: cfCommunity4, altKey: "aboutWho.sliderAlts.5" },
    { src: cfCommunity7, altKey: "aboutWho.sliderAlts.8" },
    { src: cfCommunity8, altKey: "aboutWho.sliderAlts.9" },
    { src: cfCommunity9, altKey: "aboutWho.sliderAlts.10" },
    { src: cfCommunity10, altKey: "aboutWho.sliderAlts.11" },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2400,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  const howWeWork = t("partnerWithUsPage.howWeWork.items", { returnObjects: true });
  const howWeWorkItems = Array.isArray(howWeWork) ? howWeWork : [];

  const partnerTypes = t("partnerWithUsPage.partnerTypes.items", { returnObjects: true });
  const partnerTypeItems = Array.isArray(partnerTypes) ? partnerTypes : [];

  const approachBullets = t("partnerWithUsPage.approach.bullets", { returnObjects: true });
  const approachBulletItems = Array.isArray(approachBullets) ? approachBullets : [];

  const differentFocus = t("partnerWithUsPage.different.focus", { returnObjects: true });
  const differentFocusItems = Array.isArray(differentFocus) ? differentFocus : [];

  const conversationBullets = t("partnerWithUsPage.conversation.bullets", { returnObjects: true });
  const conversationBulletItems = Array.isArray(conversationBullets) ? conversationBullets : [];

  return (
    <Container fluid className="about-section partner-with-us-page">
      <Particle />

      <Container className="partner-with-us-container">
        <header className="partner-with-us-hero">
          <h1 className="partner-with-us-hero-title">
            <Trans i18nKey="partnerWithUsPage.hero.title" components={{ purple: <span className="purple" /> }} />
          </h1>
          <p className="partner-with-us-hero-lead">{t("partnerWithUsPage.hero.lead")}</p>

          <div className="partner-with-us-hero-cta" aria-label={t("partnerWithUsPage.a11y.ctaLabel")}
          >
            <Button
              as="a"
              href={CONTACT_FORM_URL}
              target="_blank"
              rel="noreferrer"
              className="custom-yellow-btn partner-with-us-btn"
            >
              {t("partnerWithUsPage.cta.form")}
            </Button>
          </div>
        </header>

        <Row className="about-top">
          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              {t("partnerWithUsPage.headings.intro")}
            </h2>

            <div className="policy-card about-card about-who-card partner-with-us-intro-card" aria-label={t("partnerWithUsPage.a11y.introCard")}
            >
              <div className="partner-with-us-eyebrow">{t("partnerWithUsPage.eyebrow")}</div>

              <h2 className="partner-with-us-section-title">
                <Trans i18nKey="partnerWithUsPage.headings.intro" components={{ purple: <span className="purple" /> }} />
              </h2>

              <p className="about-text partner-with-us-lead">{t("partnerWithUsPage.intro.p1")}</p>
              <p className="about-text">{t("partnerWithUsPage.intro.p2")}</p>
              <p className="about-text">{t("partnerWithUsPage.intro.p3")}</p>
            </div>
          </Col>

          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              {t("partnerWithUsPage.headings.intro")}
            </h2>

            <div
              className="policy-card mission-image-card mission-slider-card mission-top-media-card about-top-media-card"
              aria-label={t("partnerWithUsPage.a11y.imageCard")}
            >
              <Slider {...sliderSettings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="mission-slide">
                    <SlickLazyImage
                      src={image.src}
                      alt={t(image.altKey)}
                      className="mission-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <section className="partner-with-us-section" aria-label={t("partnerWithUsPage.a11y.howWeWork")}
        >
          <h2 className="partner-with-us-heading">
            <Trans i18nKey="partnerWithUsPage.headings.howWeWork" components={{ purple: <span className="purple" /> }} />
          </h2>
          <p className="partner-with-us-sublead">{t("partnerWithUsPage.howWeWork.lead")}</p>

          <div className="partner-with-us-grid">
            {howWeWorkItems.map((item) => (
              <div key={item.title} className="policy-card partner-with-us-card">
                <h3 className="partner-with-us-card-title">{item.title}</h3>
                <p className="partner-with-us-card-lead">{item.lead}</p>
                <ul className="partner-with-us-list">
                  {(Array.isArray(item.bullets) ? item.bullets : []).map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="partner-with-us-section" aria-label={t("partnerWithUsPage.a11y.partnerTypes")}
        >
          <Row className="partner-with-us-split" xs={1} md={2}>
            <Col className="about-top-col">
              <div className="policy-card partner-with-us-panel">
                <h2 className="partner-with-us-heading partner-with-us-heading--left partner-with-us-heading--nowrap">
                  <Trans i18nKey="partnerWithUsPage.headings.partnerTypes" components={{ purple: <span className="purple" /> }} />
                </h2>
                <p className="partner-with-us-sublead partner-with-us-sublead--left">
                  {t("partnerWithUsPage.partnerTypes.lead")}
                </p>

                <div className="partner-with-us-chipset" aria-label={t("partnerWithUsPage.a11y.partnerTypeList")}
                >
                  {partnerTypeItems.map((label) => (
                    <span key={label} className="partner-with-us-chip">
                      {label}
                    </span>
                  ))}
                </div>
              </div>
            </Col>

            <Col className="about-top-col">
              <div className="policy-card partner-with-us-panel">
                <h2 className="partner-with-us-heading partner-with-us-heading--left">
                  <Trans i18nKey="partnerWithUsPage.headings.approach" components={{ purple: <span className="purple" /> }} />
                </h2>

                <div className="partner-with-us-quote">
                  <div className="partner-with-us-quote-label">{t("partnerWithUsPage.approach.quoteLabel")}</div>
                  <div className="partner-with-us-quote-text">{t("partnerWithUsPage.approach.quote")}</div>
                </div>

                <ul className="partner-with-us-list partner-with-us-list--tight">
                  {approachBulletItems.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>

                <p className="partner-with-us-muted">{t("partnerWithUsPage.approach.note")}</p>
              </div>
            </Col>
          </Row>
        </section>

        <section className="partner-with-us-section" aria-label={t("partnerWithUsPage.a11y.different")}
        >
          <h2 className="partner-with-us-heading">
            <Trans i18nKey="partnerWithUsPage.headings.different" components={{ purple: <span className="purple" /> }} />
          </h2>

          <Row className="partner-with-us-different" xs={1} md={2}>
            <Col className="about-top-col">
              <div className="policy-card partner-with-us-panel partner-with-us-panel--accent">
                <h3 className="partner-with-us-card-title">{t("partnerWithUsPage.different.left.title")}</h3>
                <p className="partner-with-us-card-lead">{t("partnerWithUsPage.different.left.lead")}</p>
                <ul className="partner-with-us-list">
                  {differentFocusItems.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col className="about-top-col">
              <div className="policy-card partner-with-us-panel">
                <h3 className="partner-with-us-card-title">{t("partnerWithUsPage.different.right.title")}</h3>
                <p className="partner-with-us-card-lead">{t("partnerWithUsPage.different.right.lead")}</p>
                <p className="about-text">{t("partnerWithUsPage.different.right.body")}</p>
              </div>
            </Col>
          </Row>
        </section>

        <section className="partner-with-us-section partner-with-us-section--cta" aria-label={t("partnerWithUsPage.a11y.conversation")}
        >
          <div className="policy-card partner-with-us-cta-card">
            <h2 className="partner-with-us-heading partner-with-us-heading--left">
              <Trans i18nKey="partnerWithUsPage.headings.conversation" components={{ purple: <span className="purple" /> }} />
            </h2>

            <p className="partner-with-us-sublead partner-with-us-sublead--left">{t("partnerWithUsPage.conversation.lead")}</p>

            <ul className="partner-with-us-list partner-with-us-list--tight">
              {conversationBulletItems.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>

            <div className="partner-with-us-cta-row">
              <Button
                as="a"
                href={CONTACT_FORM_URL}
                target="_blank"
                rel="noreferrer"
                className="custom-yellow-btn partner-with-us-btn"
              >
                {t("partnerWithUsPage.cta.form")}
              </Button>
            </div>

            <div className="partner-with-us-footnote">{t("partnerWithUsPage.conversation.footnote")}</div>
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default PartnerWithUs;
